/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_KeptInputs */

const cs_gdpr_review_kept = /** @type {(inputs: Gdpr_Review_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponecháno a zapsáno do auditu.`)
};

const en_gdpr_review_kept = /** @type {(inputs: Gdpr_Review_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept and written to the audit log.`)
};

/**
* | output |
* | --- |
* | "Kept and written to the audit log." |
*
* @param {Gdpr_Review_KeptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_kept = /** @type {((inputs?: Gdpr_Review_KeptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_KeptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_kept(inputs)
	return cs_gdpr_review_kept(inputs)
});